import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Statistic, Card, message } from "antd";
import CountUp from "react-countup";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import moment from "moment";

import { setMenu } from "../../redux/reducers/navigationSlice";
import { setUserAccount } from "../../redux/reducers/userAccountSlice";
import DashboardAPI from "../../api/DashboardAPI";

import "./dashboard.styles.css";

const formatter = (value) => <CountUp end={value} separator="," />;
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: `Entradas y salidas - ${moment().format("DD/MM/YYYY")}`,
    },
  },
};
const labels = ["Flujo"];

const DashboardPage = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.userAccount.user.token);
  const [messageApi, messageContext] = message.useMessage();

  const [dayVisitsIsLoading, setDayVisitsIsLoading] = useState(false);
  const [dayVisitsCount, setDayVisitsCount] = useState(0);
  const [monthVisitsIsLoading, setMonthVisitsIsLoading] = useState(false);
  const [monthVisitsCount, setMonthVisitsCount] = useState(0);
  const [entriesGraphIsLoading, setEntriesGraphIsLoading] = useState(false);
  const [entriesFlow, setEntriesFlow] = useState({
    entryCount: 0,
    exitCount: 0,
  });

  const data = {
    labels,
    datasets: [
      {
        label: "Entradas",
        data: [entriesFlow.entryCount],
        backgroundColor: "#3cb54a",
      },
      {
        label: "Salidas",
        data: [entriesFlow.exitCount],
        backgroundColor: "#f69326",
      },
    ],
  };

  const loadDayVisitsCount = useCallback(async () => {
    setDayVisitsIsLoading(true);

    try {
      const response = await DashboardAPI.getDayVisitsCount(token);
      const totalCount = response.data.totalCount;
      setDayVisitsCount(totalCount);
    } catch (ex) {
      let message = "Servicio no disponible, intente más tarde. ";

      if (ex.code !== "ERR_NETWORK") {
        message = ex.response.data.message;

        if (ex.response.status === 401) {
          dispatch(setUserAccount(null));
        }
      }

      messageApi.open({
        type: "error",
        content: message,
      });
    }
    setTimeout(() => {
      setDayVisitsIsLoading(false);
    }, 500);
  }, [dispatch, messageApi, token]);

  const loadMonthVisitsCount = useCallback(async () => {
    setMonthVisitsIsLoading(true);

    try {
      const response = await DashboardAPI.getMonthVisitsCount(token);
      const totalCount = response.data.totalCount;
      setMonthVisitsCount(totalCount);
    } catch (ex) {
      let message = "Servicio no disponible, intente más tarde. ";

      if (ex.code !== "ERR_NETWORK") {
        message = ex.response.data.message;

        if (ex.response.status === 401) {
          dispatch(setUserAccount(null));
        }
      }

      messageApi.open({
        type: "error",
        content: message,
      });
    }
    setTimeout(() => {
      setMonthVisitsIsLoading(false);
    }, 400);
  }, [dispatch, messageApi, token]);

  const loadEntriesFlowGraph = useCallback(async () => {
    setEntriesGraphIsLoading(true);

    try {
      const response = await DashboardAPI.getEntriesFlow(token);
      const { entryCount, exitCount } = response.data;
      setEntriesFlow({ entryCount, exitCount });
    } catch (ex) {
      let message = "Servicio no disponible, intente más tarde. ";

      if (ex.code !== "ERR_NETWORK") {
        message = ex.response.data.message;

        if (ex.response.status === 401) {
          dispatch(setUserAccount(null));
        }
      }

      messageApi.open({
        type: "error",
        content: message,
      });
    }
    setTimeout(() => {
      setEntriesGraphIsLoading(false);
    }, 400);
  }, [dispatch, messageApi, token]);

  useEffect(() => {
    dispatch(setMenu("dashboard"));
    loadDayVisitsCount();
    loadMonthVisitsCount();
    loadEntriesFlowGraph();
  }, [
    dispatch,
    loadDayVisitsCount,
    loadMonthVisitsCount,
    loadEntriesFlowGraph,
  ]);

  return (
    <div className="main-container">
      <>{messageContext}</>
      <div>
        <Card loading={dayVisitsIsLoading}>
          <Statistic
            title="Cantidad de visitas del día"
            value={dayVisitsCount}
            formatter={formatter}
          />
        </Card>
      </div>
      <div>
        <Card loading={monthVisitsIsLoading}>
          <Statistic
            title="Cantidad de visitas del mes"
            value={monthVisitsCount}
            formatter={formatter}
          />
        </Card>
      </div>
      <div>
        <Card loading={entriesGraphIsLoading}>
          <Bar options={options} data={data} />
        </Card>
      </div>
    </div>
  );
};

export default DashboardPage;
